import { render, staticRenderFns } from "./TabApprovalChainDivision.vue?vue&type=template&id=438e83c3&scoped=true&"
import script from "./TabApprovalChainDivision.vue?vue&type=script&lang=js&"
export * from "./TabApprovalChainDivision.vue?vue&type=script&lang=js&"
import style0 from "./TabApprovalChainDivision.vue?vue&type=style&index=0&id=438e83c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e83c3",
  null
  
)

export default component.exports